import type { Config } from "tailwindcss";

const tailwindConfig: Config = {
  darkMode: ["class"],
  content: [
    "./pages/**/*.{ts,tsx}",
    "./components/**/*.{ts,tsx}",
    "./app/**/*.{ts,tsx}",
    "./src/**/*.{ts,tsx}",
  ],
  prefix: "",
  safelist: [
    "hover:bg-ecole",
    "hover:bg-viescolaire",
    "hover:bg-classes",
    "hover:bg-blog",
    "hover:bg-espaceprive",
    "hover:bg-private",
  ],
  theme: {
    container: {
      center: true,
      padding: "2rem",
      screens: {
        "2xl": "1400px",
      },
    },
    extend: {
      fontFamily: {
        sans: ["var(--font-poppins)", "var(--font-raleway)", "sans-serif"],
        cursive: ["var(--font-comfortaa)", "cursive"],
      },
      fontSize: {
        h1: "12em",
        h2: "1.1rem",
        h3: "1rem",
        subtitle: "0.9rem",
      },
      letterSpacing: {
        wider: "1px",
        widest: "2px",
        "extra-wide": "4px",
      },
      lineHeight: {
        tight: "1.2",
        relaxed: "3",
        normal: "1.1",
      },
      colors: {
        border: "hsl(var(--border))",
        input: "hsl(var(--input))",
        ring: "hsl(var(--ring))",
        background: "hsl(var(--background))",
        foreground: "hsl(var(--foreground))",
        primary: {
          DEFAULT: "hsl(var(--primary))",
          foreground: "hsl(var(--primary-foreground))",
          dark: "hsl(var(--primary-dark))",
          light: "hsl(var(--primary-light))",
        },
        secondary: {
          DEFAULT: "hsl(var(--secondary))",
          foreground: "hsl(var(--secondary-foreground))",
          dark: "hsl(var(--secondary-dark))",
          ligth: "hsl(var(--secondary-light))",
        },
        ecole: {
          DEFAULT: "hsl(187, 72%, 71%)",
          foreground: "hsl(187, 72%, 93%)",
          light: "hsl(187, 72%, 93%)",
        },
        viescolaire: {
          DEFAULT: "hsl(46, 100%, 65%)",
          foreground: "hsl(46, 100%, 94%)",
          light: "hsl(46, 100%, 94%)",
        },
        classes: {
          DEFAULT: "hsl(122, 39%, 49%)",
          foreground: "hsl(125, 39%, 94%)",
          light: "hsl(125, 39%, 94%)",
        },
        espaceprive: {
          DEFAULT: "hsl(14, 100%, 63%)",
          foreground: "hsl(6, 71%, 95%)",
          light: "hsl(6, 71%, 95%)",
        },
        blog: {
          DEFAULT: "hsl(262, 47%, 63%)",
          foreground: "hsl(264, 45%, 94%)",
          light: "hsl(264, 45%, 94%)",
        },
        private: {
          DEFAULT: "hsl(187, 72%, 71%)",
          foreground: "hsl(187, 72%, 93%)",
          light: "hsl(187, 72%, 93%)",
        },
      },
      borderRadius: {
        lg: "var(--radius)",
        md: "calc(var(--radius) - 2px)",
        sm: "calc(var(--radius) - 4px)",
      },
      keyframes: {
        "accordion-down": {
          from: { height: "0" },
          to: { height: "var(--radix-accordion-content-height)" },
        },
        "accordion-up": {
          from: { height: "var(--radix-accordion-content-height)" },
          to: { height: "0" },
        },
        "pop-in": {
          "0%": { opacity: "0", transform: "scale(0.85)" },
          "100%": { opacity: "1", transform: "scale(1)" },
        },
        "float-slow": {
          "0%, 100%": { transform: "translateY(0)" },
          "50%": { transform: "translateY(-6px)" },
        },
      },
      animation: {
        "accordion-down": "accordion-down 0.2s ease-out",
        "accordion-up": "accordion-up 0.2s ease-out",
        "pop-in": "pop-in 0.6s ease-out forwards",
        "float-slow": "float-slow 5s ease-in-out infinite",
      },
    },
  },
  plugins: [require("tailwindcss-animate")],
};

export default tailwindConfig;
